import { HttpContextToken } from '@angular/common/http';

export const SKIP_HTTP_CACHE = new HttpContextToken<boolean>(() => false);
